import React from "react"
import {connect} from "react-redux";
import selectors from "redux/selectors";
import {IAppState} from "../../../../redux/store";

interface IState {

}

interface IProps {
    getText: (code: string, fallBack?: string, params?: { [key: string]: string | number }) => string
    code: string
    fallback?: string
    params?: {
        [key: string]: string | number
    }

}

class LocaleText extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {

        }
    }

    render() {
        const {getText, code, fallback, params} = this.props

        return <span>{getText(code, fallback, params) || code}</span>
    }
}


const mapStateToProps = (state: IAppState) => {

    return {
        getText: (code: string, fallback?: string, params?: { [key: string]: string | number }) => selectors.dictionary.getMessage(state, code, fallback, params)
    }
}

export default connect(mapStateToProps)(LocaleText)
